import React, { createContext, useContext, useMemo } from 'react';
import { useExchangeRates } from '../hooks/useExchangeRates';

const CurrencyContext = createContext(null);
const SOURCE_CURRENCY = 'DKK';

export const DISPLAY_CURRENCY_OPTIONS = [
  { label: 'DKK', value: 'DKK' },
  { label: 'USD', value: 'USD' },
  { label: 'EUR', value: 'EUR' },
];

export function CurrencyProvider({ children }) {
  const { rates, loading: ratesLoading, error: ratesError, updatedAt } = useExchangeRates();

  const value = useMemo(
    () => ({
      rates,
      ratesLoading,
      ratesError,
      ratesUpdatedAt: updatedAt,
      sourceCurrency: SOURCE_CURRENCY,
    }),
    [rates, ratesLoading, ratesError, updatedAt]
  );

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within CurrencyProvider');
  }
  return context;
}
